module.exports = __webpack_public_path__ + "media/images/deivce-both-4db805bbd397eba5833adf007c0da553.svg";